import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["partNumber", "name", "type", "openView", "enableExtraRecommendations", "enableCategoryRecommendations", "disableWarranties", "disableRecommendations", "disableOnComplete", "hideOnComplete", "setup", "onClick", "onError", "onTrolleyRequestSuccess", "children", "isComplete", "prepareTrolleyRequestIfNeeded", "updateTrolleySetup", "submitTrolleyRequest", "fetchExtraRecommendations", "fetchCategoryRecommendations", "fetchRecommendationsIfNeeded", "fetchRecommendationsCompleted", "removeModalWarranty", "isEnabled", "showIcon", "beta", "enableBasketAssetsPrefetch", "enableDefaultClick", "data-test"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import fetch from 'unfetch';
import { Button as BoltButton } from '@sainsburys-tech/bolt';
import { BagIcon, TrolleyIcon } from '@sainsburys-tech/bolt-icons';
import { useVocab } from '@sainsburys-tech/bolt-vocab-provider';
import { flatten } from '../../helpers';
import * as actions from '../../actions';
export var Button = function Button(_ref) {
  var partNumber = _ref.partNumber,
      name = _ref.name,
      type = _ref.type,
      openView = _ref.openView,
      enableExtraRecommendations = _ref.enableExtraRecommendations,
      enableCategoryRecommendations = _ref.enableCategoryRecommendations,
      disableWarranties = _ref.disableWarranties,
      disableRecommendations = _ref.disableRecommendations,
      disableOnComplete = _ref.disableOnComplete,
      hideOnComplete = _ref.hideOnComplete,
      setup = _ref.setup,
      onClick = _ref.onClick,
      onError = _ref.onError,
      onTrolleyRequestSuccess = _ref.onTrolleyRequestSuccess,
      children = _ref.children,
      isComplete = _ref.isComplete,
      prepareTrolleyRequestIfNeeded = _ref.prepareTrolleyRequestIfNeeded,
      updateTrolleySetup = _ref.updateTrolleySetup,
      submitTrolleyRequest = _ref.submitTrolleyRequest,
      fetchExtraRecommendations = _ref.fetchExtraRecommendations,
      fetchCategoryRecommendations = _ref.fetchCategoryRecommendations,
      fetchRecommendationsIfNeeded = _ref.fetchRecommendationsIfNeeded,
      fetchRecommendationsCompleted = _ref.fetchRecommendationsCompleted,
      removeModalWarranty = _ref.removeModalWarranty,
      isEnabled = _ref.isEnabled,
      showIcon = _ref.showIcon,
      beta = _ref.beta,
      enableBasketAssetsPrefetch = _ref.enableBasketAssetsPrefetch,
      enableDefaultClick = _ref.enableDefaultClick,
      dataTest = _ref['data-test'],
      props = _objectWithoutProperties(_ref, _excluded);

  useEffect(function () {
    return prepareTrolleyRequestIfNeeded(partNumber);
  });

  var handleClick = function handleClick(event) {
    onClick(event, partNumber); // Callback for custom click events
    // Default click event

    if (enableDefaultClick) {
      updateTrolleySetup(partNumber, setup);
      submitTrolleyRequest(partNumber, openView, onError, onTrolleyRequestSuccess);
      var hostPartNumber = Array.isArray(partNumber) ? partNumber[0] : partNumber;

      if (!disableRecommendations) {
        fetchRecommendationsIfNeeded(hostPartNumber);
      } else {
        if (enableExtraRecommendations) fetchExtraRecommendations(hostPartNumber);
        if (enableCategoryRecommendations) fetchCategoryRecommendations(hostPartNumber);
        fetchRecommendationsCompleted(hostPartNumber);
      }

      if (disableWarranties) {
        removeModalWarranty();
      }

      if (enableBasketAssetsPrefetch) {
        fetch('/basket/asset-manifest.json').then(function (response) {
          return response.json();
        }).then(function (manifest) {
          Object.keys(manifest).forEach(function (file) {
            if (file.indexOf('client') > -1) {
              var link = document.createElement('link');
              link.rel = 'prefetch';
              link.href = manifest[file];
              document.head.appendChild(link);
            }
          });
        }).catch(function () {
          /* fail silently */
        });
      }
    }
  };

  var _useVocab = useVocab(),
      ITEM_CONTAINER = _useVocab.ITEM_CONTAINER;

  var brandedTrolleyIcon = function brandedTrolleyIcon() {
    if (ITEM_CONTAINER === 'bag') return /*#__PURE__*/React.createElement(BagIcon, {
      width: "18px",
      height: "20px"
    });
    return /*#__PURE__*/React.createElement(TrolleyIcon, {
      width: "18px",
      height: "20px"
    });
  };

  var trolleyText = /*#__PURE__*/React.createElement("span", null, "Add", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, " ", name), " to ", ITEM_CONTAINER);
  var show = !hideOnComplete || !isComplete;
  var disabled = !isEnabled || disableOnComplete && isComplete;
  return show && /*#__PURE__*/React.createElement(BoltButton, _extends({
    kind: type,
    disabled: disabled,
    onClick: handleClick,
    "data-test": "".concat(dataTest, "-button")
  }, props), (beta || showIcon) && brandedTrolleyIcon(), /*#__PURE__*/React.createElement("span", null, children || trolleyText));
};
Button.propTypes = {
  partNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array]).isRequired,
  name: PropTypes.string.isRequired,
  openView: PropTypes.bool,
  enableExtraRecommendations: PropTypes.bool,
  enableCategoryRecommendations: PropTypes.bool,
  disableWarranties: PropTypes.bool,
  disableRecommendations: PropTypes.bool,
  disableOnComplete: PropTypes.bool,
  hideOnComplete: PropTypes.bool,
  setup: PropTypes.func,
  onClick: PropTypes.func,
  onError: PropTypes.func,
  onTrolleyRequestSuccess: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  isComplete: PropTypes.bool,
  prepareTrolleyRequestIfNeeded: PropTypes.func,
  updateTrolleySetup: PropTypes.func,
  submitTrolleyRequest: PropTypes.func,
  fetchExtraRecommendations: PropTypes.func,
  fetchCategoryRecommendations: PropTypes.func,
  fetchRecommendationsIfNeeded: PropTypes.func,
  fetchRecommendationsCompleted: PropTypes.func,
  removeModalWarranty: PropTypes.func,
  isEnabled: PropTypes.bool,
  showIcon: PropTypes.bool,
  beta: PropTypes.bool,
  enableBasketAssetsPrefetch: PropTypes.bool,
  enableDefaultClick: PropTypes.bool
};
Button.defaultProps = {
  type: 'primary',
  openView: false,
  disableWarranties: false,
  disableRecommendations: false,
  disableOnComplete: false,
  hideOnComplete: false,
  showIcon: false,
  isEnabled: true,
  setup: function setup() {},
  onClick: function onClick() {},
  onError: function onError() {},
  onTrolleyRequestSuccess: null,
  'data-test': 'component-att',
  beta: false,
  enableBasketAssetsPrefetch: false,
  enableDefaultClick: true
};
export var mapStateToProps = function mapStateToProps(state, props) {
  var _flatten = flatten(state),
      trolleyItems = _flatten.trolleyItems;

  var addedTrolleyItems = trolleyItems && trolleyItems.added || [];
  return {
    isComplete: addedTrolleyItems.includes(props.partNumber)
  };
};
export default connect(mapStateToProps, _objectSpread({}, actions))(Button);